module.exports = __webpack_public_path__ + "static/media/user.ce9143bc.png";